//startup settings
function startup(klevu) {
    var options = {
        powerUp: {
            recsModule: true,
            landing: false
            // catnav: false // we will set to TRUE below, after our overrides
        },
        recs: {
            apiKey: 'klevu-164908610292114993'
        },
        url: {
            search: klevu.settings.url.protocol + '//eucs29v2.ksearchnet.com/cs/v2/search',
            landing: '/pages/search-results',
            protocolFull: klevu.settings.url.protocol + "//"

        },
        localSettings: true,
        search: {
            searchBoxSelector: "#searchedKeyword",
            searchBoxTarget: false,
            minChars: 1,
            placeholder: "Search",
            showQuickOnEnter: false,
            fullPageLayoutEnabled: false,
            personalisation: false,
            redirects: {},// populated below
            apiKey: 'klevu-164908610292114993',
            limit: 24
        },
        analytics: {
            apiKey: 'klevu-164908610292114993'
        },
        catnav: {
            loadDefaultStyles: false
        },
        /*
         * The filters key is not a part of Klevu's JS lib. It's used later when
         * settings filter limits for search results and PLPs
         */
        filters: {
            limit: 100
        }
    };

    // Customization by 1R needed to implement search redirects
    // Redirects from the app can be found here:
    // https://js.klevu.com/klevu-js-v1/klevu-js-api/klevu-162810598967514030-maps.js
    var redirectsUrl = 'https://js.klevu.com/klevu-js-v1/klevu-js-api/klevu-164908610292114993-maps.json';
    $.ajax({
        type: 'get',
        url: redirectsUrl,
        error: function (err) {
            console.log("get redirect err", err);
        },
        success: function (data) {
            // console.log("data", data);
            buildRedirectObj(data);
        }
    }).then(function () {
        // We only want to start klevu after pulling the redirect url's
        // However we can still start klevu if the redirect ajax request fails
        klevu(options);
    });

    function buildRedirectObj(data) {
        var urlMap = data.klevu_keywordUrlMap;
        for (let index = 0; index < urlMap.length; index++) {
            const redirect = urlMap[index].url;
            for (let kindex = 0; kindex < urlMap[index].keywords.length; kindex++) {
                const keyword = urlMap[index].keywords[kindex].replace('"', '');
                options.search.redirects[keyword] = redirect;
            }
        }
    }
}

//once klevu is interactive, setup the settings
klevu.interactive(function () {
    startup(klevu);
    console.log("klevu startup");
});

// //check if klevu is interactive and also if all necessary search instances are powered up
// klevu.coreEvent.build({
//     name : "bindLocalBoxes",
//     fire: function(){
//         console.log("klevu bindLocalBoxes");
//         if ( !klevu.isInteractive || klevu.isUndefined(klevu.search) || klevu.isUndefined(klevu.search.build) || klevu.isUndefined(klevu.searchEvents) || klevu.isUndefined(klevu.searchEvents.functions) || klevu.isUndefined(klevu.searchEvents.functions.bindAllSearchBoxes) ) {return false;} return true;
//     },
//     maxCount: 500,
//     delay:30
// });
// //attach to all search boxes on the page
// klevu.coreEvent.attach("bindLocalBoxes",{
//     name: "search-boxes-local-boxes" ,
//     fire: function(){
//         klevu.searchEvents.functions.bindAllSearchBoxes.fire();
//     }
// });